import { CalendarDays } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangLichDang } from './pages/TrangLichDang.js';

const schedule: KhaiBaoModule = {
  id: 'schedule',
  nav: {
    group: 'NỘI DUNG',
    label: 'Lịch đăng',
    icon: CalendarDays,
    order: 2,
    permission: 'schedule',
    to: '/lich-dang',
  },
  routes: [
    {
      path: '/lich-dang',
      element: createElement(TrangLichDang),
      permission: { module: 'schedule', level: 'view' },
    },
  ],
};

export default schedule;
